// Wekeza-Smart Translation Dictionary
// English to Swahili vocabulary for investment education

export const vocabulary = {
  // User-provided vocabulary
  practical: 'Uhalisia',
  theory: 'Nadharia',
  pressure: 'Shinikizo',
  context: 'Muktadha',
  expectations: 'Matarajio',
  projections: 'Utabiri',
  'market trend': 'Mwendendo wa soko',
  sustainable: 'Himilivu',
  'consistent market': 'Uthabiti wa soko',
  prove: 'Thibitisha',
  evaluation: 'Tathmini',
  liquidity: 'Ukwasi',
  match: 'Kurandana',
  harmonize: 'Kurandana',
  resemble: 'Shabihiana',
  correspond: 'Shabihiana',
  
  // Investment terms
  portfolio: 'Portfolio',
  investment: 'Uwekezaji',
  stocks: 'Hisa',
  shares: 'Hisa',
  bonds: 'Bondi',
  'treasury bills': 'Dhamana za Hazina',
  dividend: 'Gawio',
  returns: 'Faida',
  profit: 'Faida',
  loss: 'Hasara',
  risk: 'Hatari',
  'risk level': 'Kiwango cha Hatari',
  conservative: 'Makini',
  moderate: 'Wastani',
  aggressive: 'Kali',
  
  // Market terms
  market: 'Soko',
  'stock exchange': 'Soko la Hisa',
  'market cap': 'Thamani ya Soko',
  'trading volume': 'Kiasi cha Biashara',
  'price change': 'Mabadiliko ya Bei',
  'year to date': 'Mwaka hadi Sasa',
  'ytd': 'YTD',
  bullish: 'Kupanda',
  bearish: 'Kushuka',
  volatility: 'Msukosuko',
  
  // Financial terms
  interest: 'Riba',
  'interest rate': 'Kiwango cha Riba',
  maturity: 'Ukomavu',
  yield: 'Mavuno',
  capital: 'Mtaji',
  'capital gain': 'Faida ya Mtaji',
  assets: 'Mali',
  liabilities: 'Madeni',
  equity: 'Usawa',
  debt: 'Deni',
  
  // Action words
  buy: 'Nunua',
  sell: 'Uza',
  hold: 'Shika',
  invest: 'Wekeza',
  save: 'Hifadhi',
  withdraw: 'Toa',
  deposit: 'Weka',
  transfer: 'Hamisha',
  
  // Analysis terms
  analysis: 'Uchambuzi',
  analyze: 'Chambua',
  compare: 'Linganisha',
  calculate: 'Hesabu',
  simulate: 'Jaribu',
  forecast: 'Utabiri',
  predict: 'Tabiri',
  recommend: 'Pendekeza',
  
  // Time periods
  daily: 'Kila siku',
  weekly: 'Kila wiki',
  monthly: 'Kila mwezi',
  quarterly: 'Kila robo mwaka',
  annually: 'Kila mwaka',
  'short-term': 'Muda mfupi',
  'long-term': 'Muda mrefu',
  
  // User interface
  dashboard: 'Dashibodi',
  home: 'Nyumbani',
  settings: 'Mipangilio',
  profile: 'Wasifu',
  logout: 'Ondoka',
  login: 'Ingia',
  register: 'Jisajili',
  submit: 'Wasilisha',
  cancel: 'Ghairi',
  save: 'Hifadhi',
  edit: 'Hariri',
  delete: 'Futa',
  add: 'Ongeza',
  remove: 'Ondoa',
  view: 'Tazama',
  search: 'Tafuta',
  filter: 'Chuja',
  sort: 'Panga',
  
  // Education
  learn: 'Jifunze',
  lesson: 'Somo',
  module: 'Moduli',
  quiz: 'Mtihani',
  certificate: 'Cheti',
  progress: 'Maendeleo',
  beginner: 'Mwanzo',
  intermediate: 'Wastani',
  advanced: 'Juu',
  
  // Alerts & notifications
  alert: 'Arifa',
  notification: 'Taarifa',
  reminder: 'Kikumbusho',
  warning: 'Onyo',
  success: 'Mafanikio',
  error: 'Hitilafu',
  
  // Goals
  goal: 'Lengo',
  target: 'Shabaha',
  milestone: 'Hatua',
  achievement: 'Mafanikio',
  
  // Misc
  total: 'Jumla',
  average: 'Wastani',
  minimum: 'Kiwango cha chini',
  maximum: 'Kiwango cha juu',
  current: 'Ya sasa',
  previous: 'Iliyopita',
  next: 'Inayofuata',
  all: 'Zote',
  none: 'Hakuna',
  other: 'Nyingine',
};

// Reverse lookup: Swahili to English
export const vocabularySwToEn = Object.fromEntries(
  Object.entries(vocabulary).map(([en, sw]) => [sw.toLowerCase(), en])
);

// Common phrases
export const phrases = {
  en: {
    welcome: 'Welcome to Wekeza-Smart!',
    investmentJourney: 'Start your investment journey',
    marketData: 'Market data updated daily',
    disclaimer: 'For informational purposes only. Not financial advice.',
    regulatedBy: 'Regulated by CMSA & BOT',
    practicalExperience: 'Gain practical experience through our simulator',
    theoryAndPractice: 'Learn both theory and practical investment skills',
    marketPressure: 'Understand market pressure and how to handle it',
    investmentContext: 'Investment decisions depend on your personal context',
    manageExpectations: 'Manage your investment expectations realistically',
    viewProjections: 'View future projections for your portfolio',
    followTrends: 'Follow market trends to make informed decisions',
    sustainableGrowth: 'Focus on sustainable growth over quick gains',
    consistentReturns: 'Aim for consistent market returns',
    proveYourStrategy: 'Prove your strategy with our simulator',
    portfolioEvaluation: 'Get a comprehensive portfolio evaluation',
    checkLiquidity: 'Check the liquidity of your investments',
    matchGoals: 'Match your investments to your financial goals',
  },
  sw: {
    welcome: 'Karibu Wekeza-Smart!',
    investmentJourney: 'Anza safari yako ya uwekezaji',
    marketData: 'Data ya soko inasasishwa kila siku',
    disclaimer: 'Kwa madhumuni ya taarifa tu. Si ushauri wa kifedha.',
    regulatedBy: 'Inadhibitiwa na CMSA & BOT',
    practicalExperience: 'Pata uhalisia kupitia kihesabu chetu',
    theoryAndPractice: 'Jifunze nadharia na uhalisia wa uwekezaji',
    marketPressure: 'Elewa shinikizo la soko na jinsi ya kushughulikia',
    investmentContext: 'Maamuzi ya uwekezaji yanategemea muktadha wako',
    manageExpectations: 'Simamia matarajio yako ya uwekezaji kwa uhalisia',
    viewProjections: 'Tazama utabiri wa portfolio yako ya baadaye',
    followTrends: 'Fuata mwendendo wa soko kufanya maamuzi sahihi',
    sustainableGrowth: 'Zingatia ukuaji himilivu badala ya faida ya haraka',
    consistentReturns: 'Lenga uthabiti wa soko katika faida',
    proveYourStrategy: 'Thibitisha mkakati wako na kihesabu chetu',
    portfolioEvaluation: 'Pata tathmini kamili ya portfolio yako',
    checkLiquidity: 'Angalia ukwasi wa uwekezaji wako',
    matchGoals: 'Kurandana uwekezaji wako na malengo yako ya kifedha',
  }
};

// Helper function to translate a word
export const translateWord = (word, targetLang = 'sw') => {
  const lowerWord = word.toLowerCase();
  if (targetLang === 'sw') {
    return vocabulary[lowerWord] || word;
  } else {
    return vocabularySwToEn[lowerWord] || word;
  }
};

// Helper function to get a phrase
export const getPhrase = (key, lang = 'en') => {
  return phrases[lang]?.[key] || phrases.en[key] || key;
};
